import { WebBoxIcon } from './WebBoxIcon';

/**
 * author: Samuel Jones
 * id 42B55CB7-DC3D-4804-A848-1A9CA7DCD533
 * name web-box
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/web-box.svg
 * tags
 * - Geographic Information System 
 */
export const InternetBoxIcon = WebBoxIcon;
export default InternetBoxIcon